import axios from 'axios';
import { getApiUrl } from '../config';
import { kitchenClientHeaders } from './clientContext';
import { getEffectiveAuthToken, recoverFromAuthenticationFailure } from './authToken';

// Create an axios instance
const api = axios.create({
  baseURL: getApiUrl(''),
});

// Function to handle authentication errors
const handleAuthError = (error: any) => {
  // If the status is 401 Unauthorized
  if (error.response?.status === 401) {
    console.log('Unauthorized access - Token expired or invalid');
    
    recoverFromAuthenticationFailure();
  }
  
  return Promise.reject(error);
};

// Add a request interceptor to add the token to requests
api.interceptors.request.use(
  (config: any) => {
    // Get the token from localStorage
    const token = getEffectiveAuthToken();
    
    // If token exists, add to headers
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.headers) {
      Object.assign(config.headers, kitchenClientHeaders());
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error) => {
    return handleAuthError(error);
  }
);

export default api;
